import { render } from "./activityDetail.vue?vue&type=template&id=5680ad0e&scoped=true"
import script from "./activityDetail.vue?vue&type=script&lang=js"
export * from "./activityDetail.vue?vue&type=script&lang=js"

import "./activityDetail.vue?vue&type=style&index=0&id=5680ad0e&lang=less&scoped=true"

import exportComponent from "/var/www/html/pro-cms-dtinsights/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5680ad0e"]])

export default __exports__